import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledFoodWrapper,
  StyledFoodDetails,
  StyledFoodType,
  StyledFoodTypeLabel,
  StyleFoodNumber,
  StyleFoodSubtitle
} from './style';

const FoodPaybill = ({ type, quantity, className }) => (
  <StyledFoodWrapper type={type} className={className}>
    <StyledFoodType>
      <StyledFoodTypeLabel>{type}</StyledFoodTypeLabel>
    </StyledFoodType>
    <StyledFoodDetails type={type}>
      <StyleFoodNumber type={type}>{quantity}</StyleFoodNumber>
      <StyleFoodSubtitle type={type}> Vales de comida </StyleFoodSubtitle>
    </StyledFoodDetails>
  </StyledFoodWrapper>
);

FoodPaybill.propTypes = {
  type: PropTypes.string,
  quantity: PropTypes.number,
  className: PropTypes.string
};

export default FoodPaybill;
